import type { SymbolDefinition } from "./types";

export const SYMBOLS: SymbolDefinition[] = [
  {
    id: "sp500",
    label: "S&P 500",
    shortLabel: "S&P 500",
    category: "index",
    market: "US",
    currency: "USD",
    timezone: "America/New_York",
    providerSymbols: { alphaVantage: "SPY", stooq: "^spx", yahoo: "^GSPC" },
    decimals: 2,
    flagOrIcon: "US"
  },
  {
    id: "nasdaq100",
    label: "NASDAQ 100",
    shortLabel: "NDX",
    category: "index",
    market: "US",
    currency: "USD",
    timezone: "America/New_York",
    providerSymbols: { alphaVantage: "QQQ", stooq: "^ndx", yahoo: "^NDX" },
    decimals: 2,
    flagOrIcon: "US"
  },
  {
    id: "sox",
    label: "PHLX Semiconductor",
    shortLabel: "SOX",
    category: "index",
    market: "US",
    currency: "USD",
    timezone: "America/New_York",
    providerSymbols: { stooq: "^sox", yahoo: "^SOX" },
    decimals: 2,
    flagOrIcon: "US"
  },
  {
    id: "nikkei225",
    label: "Nikkei 225",
    shortLabel: "Nikkei",
    category: "index",
    market: "JP",
    currency: "JPY",
    timezone: "Asia/Tokyo",
    providerSymbols: { stooq: "^nkx", yahoo: "^N225" },
    decimals: 2,
    flagOrIcon: "JP"
  },
  {
    id: "usdjpy",
    label: "USD/JPY",
    shortLabel: "USD/JPY",
    category: "fx",
    market: "FX",
    currency: "JPY",
    timezone: "Etc/UTC",
    providerSymbols: { alphaVantage: "USD/JPY", yahoo: "JPY=X" },
    decimals: 3,
    flagOrIcon: "FX"
  },
  {
    id: "btcusd",
    label: "BTC/USD",
    shortLabel: "BTC",
    category: "crypto",
    market: "Crypto",
    currency: "USD",
    timezone: "Etc/UTC",
    providerSymbols: { alphaVantage: "BTC/USD", yahoo: "BTC-USD" },
    decimals: 2,
    flagOrIcon: "BTC"
  }
];

export function getSymbolDefinition(symbolId: string): SymbolDefinition {
  const symbol = SYMBOLS.find((candidate) => candidate.id === symbolId);
  if (!symbol) throw new Error(`Unknown symbol: ${symbolId}`);
  return symbol;
}
